var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"fill":"#64B5F6","d":"M45,35c0,2.208-1.791,4-4,4H7c-2.209,0-4-1.792-4-4V13c0-2.21,1.791-4,4-4h34c2.209,0,4,1.79,4,4V35z"}}),_c('path',{attrs:{"fill":"#37474F","d":"M3 14H45V20H3z"}}),_c('path',{attrs:{"fill":"#E3F2FD","d":"M5 22H43V27H5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }